module.exports = __webpack_public_path__ + "img/pfp.00cdc67b.png";